import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { GroupObject, EventEmit, EventEmitArray, } from './Bs4Utils'
import { SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import useMediaQuery from '@mui/material/useMediaQuery';

const DIRECTION_COLUMN = 'column';
const DIRECTION_COLUMN_REVERSE = 'column-reverse';
const groupObject = new GroupObject();

// const useWideScreen = () => {
//   const minWidth = useMediaQuery('screen and (min-width: 900px)');
//   const maxHeight = useMediaQuery('screen and (max-height: 500px)');
//   // const landscape = useMediaQuery(' (orientation: landscape)');
//   // const portrait = useMediaQuery(' (orientation: portrait)');
//   return minWidth && maxHeight;
// }

let hideTopMenuForMobile = false;
export const setHideTopMenuForMobile = (hide) => {
  hideTopMenuForMobile = hide;
}

function isTouchDevice() {
  return navigator.maxTouchPoints > 0
  // console.log('...HideOnScroll...touch', ('ontouchstart' in window), window.ontouchstart, navigator.maxTouchPoints);
  // return (('ontouchstart' in window) ||
  //    (navigator.maxTouchPoints > 0) ||
  //    (navigator.msMaxTouchPoints > 0));
}

const resetHeight = (type, show) => {
  // console.log(new Error('...HideOnScroll...resetHeight'), type, show);
  const objects = groupObject.get(['AppBar', type]);  
  for (const object of objects) {    
    //object.ref1.current.setAttribute('style', `height: ${show ? object.ref2.current.offsetHeight : 0}px`);
    object.ref1.current.setAttribute('style', `height: ${show ? 'auto' : 0}px`);
  }
}

const scrollTarget = (scrollNode, type, delta) => {
  // console.log('...HideOnScroll...scrollTarget');
  if (!scrollNode) return;  
  if (!hideTopMenuForMobile) return;
  
  const objects = groupObject.get(['AppBar', type]);
  
  let height1ColumnReverse = 0;
  let height2ColumnReverse = 0;
  let height1Column = 0;
  let height2Column = 0;
  let objectsColumnReverse = [];
  let objectsColumn = [];
  for (const object of objects) {
    if (object.direction === DIRECTION_COLUMN_REVERSE) {
      objectsColumnReverse.push(object);
      height1ColumnReverse += object.ref1.current.offsetHeight;
      height2ColumnReverse += object.ref2.current.offsetHeight;
    }
    if (object.direction === DIRECTION_COLUMN) {
      objectsColumn.push(object);
      height1Column += object.ref1.current.offsetHeight;
      height2Column += object.ref2.current.offsetHeight;
    }
  }

  const maxHeight = Math.max(height2ColumnReverse, height2Column);
  const sumHeight = height1ColumnReverse + height1Column;

  const ws = ((window.innerWidth > window.innerHeight) && (maxHeight * 3 > sumHeight + scrollNode.offsetHeight));
  // console.log('...HideOnScroll...scrollTarget.ws', type, ws, `(${window.innerWidth > window.innerHeight}) && (${maxHeight} * 3 > ${sumHeight + scrollNode.offsetHeight})`);
  if (ws) {
    if (height1ColumnReverse > 0 || height1Column > 0) resetHeight(type, false);
    // console.log('...HideOnScroll...scrollTarget.ws', '------------------');
    return;
  }

  const safeArea = 200;
  const ls = (safeArea + sumHeight + scrollNode.offsetHeight > scrollNode.scrollHeight);
  // console.log('...HideOnScroll...scrollTarget.ls', type, ls, `(${safeArea + sumHeight + scrollNode.offsetHeight} > ${sumHeight + scrollNode.scrollHeight})`);
  if (ls) {
    if (height1ColumnReverse < height2ColumnReverse || height1Column < height1Column) resetHeight(type, true);
    // console.log('...HideOnScroll...scrollTarget.ls', type, ls, '-----------------------');
    return;
  }

  if (delta === 0) return;

  if (Math.sign(delta) < 0) {
    objectsColumnReverse = objectsColumnReverse.reverse();      
  } else {
    objectsColumn = objectsColumn.reverse();
  }

  const deltaCurrent = Math.max(Math.abs(delta) / 2, 1) * Math.sign(delta);
  let deltaColumnReverse = deltaCurrent;
  for (const object of objectsColumnReverse) {
    const offsetHeight2 = object.ref2.current.offsetHeight;
    let offsetHeight1 = object.ref1.current.offsetHeight - deltaColumnReverse;
    deltaColumnReverse = 0;
    if (offsetHeight1 < 0) {
      deltaColumnReverse = -offsetHeight1;
      offsetHeight1 = 0;
    } else if (offsetHeight1 > offsetHeight2) {        
      deltaColumnReverse = offsetHeight2 - offsetHeight1;
      offsetHeight1 = offsetHeight2;
    }
    object.ref1.current.setAttribute('style', `height: ${offsetHeight1}px`);      
  }

  let deltaColumn = - deltaCurrent;
  for (const object of objectsColumn) {
    const offsetHeight2 = object.ref2.current.offsetHeight;
    let offsetHeight1 = object.ref1.current.offsetHeight - deltaColumn;
    deltaColumn = 0;
    if (offsetHeight1 < 0) {
      deltaColumn = -offsetHeight1;
      offsetHeight1 = 0;
    } else if (offsetHeight1 > offsetHeight2) {        
      deltaColumn = offsetHeight2 - offsetHeight1;
      offsetHeight1 = offsetHeight2;
    }
    object.ref1.current.setAttribute('style', `height: ${offsetHeight1}px`);      
  }
}

export const useScrollTarget = (type, disabled) => {
  type = String(type);
  const [scrollNode, setScrollNode] = React.useState(null);
  const smallScreen = React.useContext(SmallScreenContext);  
  // const hasTouch = window.matchMedia('(pointer: coarse)').matches; // ok ok ok !!!

  // console.log('...HideOnScroll...useScroll', 'ss:', smallScreen);
  if (smallScreen) scrollTarget(scrollNode, type, 0);
  else resetHeight(type, true);
  
  React.useEffect(() => {
    if (!scrollNode) return;
    if (disabled) return;

    let top = scrollNode.scrollTop;    
    const handleScroll = (event) => {             
      if (type) {
        const delta = scrollNode.scrollTop - top;
        scrollTarget(scrollNode, type, delta);
      }
      top = scrollNode.scrollTop;
    }    
  
    if (smallScreen && hideTopMenuForMobile) {
      scrollNode?.addEventListener('scroll', handleScroll, {passive: true});
    } else {
      resetHeight(type, true);
    }
    return () => scrollNode?.removeEventListener('scroll', handleScroll, {passive: true});
  }, [scrollNode, smallScreen]);

  return setScrollNode;
}

export const HideOnScroll = (props) => {    
  const ref1 = React.useRef(null);
  const ref2 = React.useRef(null);
  const direction = React.useMemo(() => props.direction === 'up' ? DIRECTION_COLUMN : DIRECTION_COLUMN_REVERSE, [props.direction]);

  React.useEffect(() => { 
    const object = {
      type: String(props.type),
      direction: direction,      
      ref1: ref1,
      ref2: ref2,      
      debug: props.debug,
    }
    groupObject.add(String(props.type), object);
    return () => groupObject.remove(object);
  }, [ref2, ref2, direction, props.type]);
  
  return (    
    <Stack
      id='HideOnScroll'
      ref={ref1}
      direction={direction}
      sx={{ 
        width: '100%', 
        overflow: 'hidden',
      }}
    >
      <Box ref={ref2}>
        {props.children}
      </Box>
    </Stack>
  );
}